//@flow
import {
  endpoints,
  createHeaderBannerApi,
  deleteHeaderBannerApi,
  getHeaderBannerApi,
  listHeaderBannersApi,
  updateHeaderBannerApi,
} from '../api/header-banner';

import type {HeaderBannerRequest} from '../api/header-banner';
import type {HeaderBanner} from '../../../entities';
import {buildRoute} from '../../../http';

export function createHeaderBannerService(
  data: HeaderBannerRequest
): Promise<HeaderBanner> {
  return createHeaderBannerApi(data).toPromise();
}

export function listHeaderBannersService(): Promise<HeaderBanner[]> {
  return listHeaderBannersApi().toPromise();
}

export function getHeaderBannerService(
  bannerId: string
): Promise<HeaderBanner> {
  const route = buildRoute(endpoints.GET_HEADER_BANNER, [bannerId]);
  return getHeaderBannerApi(undefined, {route}).toPromise();
}

export function deleteHeaderBannerService(bannerId: string): Promise<void> {
  const route = buildRoute(endpoints.DELETE_HEADER_BANNER, [bannerId]);
  return deleteHeaderBannerApi({route}).toPromise();
}

export function updateHeaderBannerService(
  bannerId: string,
  data: $Shape<HeaderBannerRequest>
): Promise<HeaderBanner> {
  const route = buildRoute(endpoints.UPDATE_HEADER_BANNER, [bannerId]);
  return updateHeaderBannerApi(data, {route}).toPromise();
}
